import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'DbNumberParseIntPipe',
    standalone: false
})

export class DbNumberParseIntPipe implements PipeTransform {
  transform(value: string): number {
    return parseInt(value, 10);
  }
}
